import React, { useState, useEffect, useRef } from "react";
import { Column } from "primereact/column";
import { DataTable } from "primereact/datatable";
import { timesheetApi } from "../../services";
import { Button } from "primereact/button";
import { toast } from "react-toastify";
import { Dialog } from "primereact/dialog";
import RejectRecallTimesheetPopup from "./dialogBox/rejectRecallTimesheetPopup";

const ReviewRecallTimesheet = ({ userData }) => {
  const dt = useRef(null);
  const [reviewRecallTimesheet, setReviewRecallTimesheet] = useState([]);
  const [rejectRowData, setRejectRowData] = useState({});
  const [rejectAllRowData, setRejectAllRowData] = useState({});
  const [rejectDialog, setRejectDialog] = useState(false);
  const [allRejectDialog, setAllRejectDialog] = useState(false);
  const [empReviewRecallTimesheetDisabled, setEmpReviewRecallTimesheetDisabled] = useState(true);

  let count = 0;
  useEffect(() => {
    if (count == 0) {
      fetchReviewRecallTimesheet();
      count++;
    }
  }, [userData]);

  const fetchReviewRecallTimesheet = () => {
    let param = {
      userId: userData.id,
    };
    timesheetApi.getReviewRecallTimesheet(param).then((resp) => {
      try {
        if (resp?.data?.data?.length > 0) {
          setEmpReviewRecallTimesheetDisabled(false);
        }
        setReviewRecallTimesheet(resp?.data?.data);
      } catch (error) {
        // Error handle
      }
    });
  };

  const rejectTimesheetRecall = (rowData) => {
    setRejectRowData(rowData);
    setRejectDialog(true);
  };

  const rejectTimesheetData = (data) => {
    let param = {
      timesheetIds: [rejectRowData.timesheetId],
      status: "REJECT",
      reason: data.reason,
    };
    try {
      // put api call
      timesheetApi.approveRejectRecalledTimesheet(param).then(
        (resp) => {
          fetchReviewRecallTimesheet();
          toast.success(userData?.name + " Recall timesheet has been rejected...");
        },
        (err) => {
          toast.error("Unable to reject recall timesheet...");
        }
      );
    } catch (error) {
      toast.error("Unable to reject recall timesheet...");
    }
  };

  const rejectAllTimesheetRecall = (rowData) => {
    setRejectAllRowData(rowData);
    setAllRejectDialog(true);
  };

  const rejectAllTimesheetData = (data) => {
    let rejectEmpId = rejectAllRowData.map((a) => a.timesheetId);
    let param = {
      timesheetIds: rejectEmpId,
      status: "REJECT",
      reason: data.reason,
    };
    try {
      // put api call
      timesheetApi.approveRejectRecalledTimesheet(param).then(
        (resp) => {
          fetchReviewRecallTimesheet();
          toast.success(userData?.name + " All recall timesheet has been rejected...");
        },
        (err) => {
          toast.error("Unable to reject all recall timesheet...");
        }
      );
    } catch (error) {
      toast.error("Unable to reject all recall timesheet...");
    }
  };

  const RejectTimesheetDialog = () => {
    return (
      <Dialog className="pop-up-dialog-recall" header={"Reject Recall Timesheet (" + rejectRowData?.date + ")"}
        visible={rejectDialog} style={{ width: '530px' }} onHide={() => setRejectDialog(false)}>
        <RejectRecallTimesheetPopup
          recallRejectRow={(data) => rejectTimesheetData(data)}
          rejectRow={rejectRowData}
          onClose={(e) => {
            setRejectDialog(false);
          }} />
      </Dialog>
    );
  };

  const RejectAllTimesheetDialog = () => {
    return (
      <Dialog className="pop-up-dialog-recall" header="Reject Recall Timesheet"
        visible={allRejectDialog} style={{ width: '380px' }} onHide={() => setAllRejectDialog(false)}>
        <RejectRecallTimesheetPopup
          recallRejectRow={(data) => rejectAllTimesheetData(data)}
          rejectRow={rejectAllRowData}
          onClose={(e) => {
            setAllRejectDialog(false);
          }} />
      </Dialog>
    );
  };
  /* Dialog Box for Recall timesheet End */

  const approveTimesheetRecall = (reviewRecallTimesheet) => {
    let param;
    param = {
      timesheetIds: [reviewRecallTimesheet.timesheetId],
      status: "APPROVE",
      reason: "APPROVED",
    };
    try {
      timesheetApi.approveRejectRecalledTimesheet(param).then(
        (resp) => {
          fetchReviewRecallTimesheet();
          toast.success(userData?.name + " Recall timesheet has been approved...");
        },
        (err) => {
          toast.error("Unable to approve recall timesheet...");
        }
      );
    } catch (error) {
      toast.error("Unable to approve recall timesheet...");
    }
  };

  const approveAllTimesheetRecall = (reviewRecallTimesheet) => {
    let approvedEmpId = reviewRecallTimesheet.map((a) => a.timesheetId);
    let param;
    param = {
      timesheetIds: approvedEmpId,
      status: "APPROVE",
      reason: "APPROVED",
    };
    try {
      timesheetApi.approveRejectRecalledTimesheet(param).then(
        (resp) => {
          fetchReviewRecallTimesheet();
          toast.success(userData?.name + " Recall timesheet has been approved...");
        },
        (err) => {
          toast.error("Unable to approve recall timesheet...");
        }
      );
    } catch (error) {
      toast.error("Unable to approve recall timesheet...");
    }
  };

  const reviewActionBodyTemplate = (reviewRecallTimesheet) => {
    return (
      <React.Fragment>
        <Button icon="pi pi-times" className="p-button-rounded p-button-danger mr-2" aria-label="Cancel"
          tooltip="Reject Recall Timesheet" tooltipOptions={{ position: "top" }} onClick={() => rejectTimesheetRecall(reviewRecallTimesheet)} />
        <Button icon="pi pi-check" className="p-button-rounded" aria-label="Submit"
          tooltip="Approve Recall Timesheet" tooltipOptions={{ position: "top" }} onClick={() => approveTimesheetRecall(reviewRecallTimesheet)} />
      </React.Fragment>
    );
  };

  return (
    <>
      <div className="datatable-style-demo">
        <DataTable paginator responsiveLayout="scroll"
          paginatorTemplate="CurrentPageReport FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink RowsPerPageDropdown"
          currentPageReportTemplate="Showing {first} to {last} of {totalRecords}" rows={10} rowsPerPageOptions={[10, 20, 50]}
          columnResizeMode="fit" scrollable="horizontal" dataKey="id" stripedRows ref={dt}
          value={reviewRecallTimesheet}>
          <Column field="timesheetId" header="Timesheet Id" style={{ minWidth: "8rem" }} ></Column>
          <Column field="date" header="Date" style={{ minWidth: "10rem" }}></Column>
          <Column field="reason" header="Reason" style={{ minWidth: "20rem" }}></Column>
          <Column field="" header="Action" body={reviewActionBodyTemplate} style={{ minWidth: "10rem" }}></Column>
        </DataTable>
      </div>
      {RejectTimesheetDialog()}
      {RejectAllTimesheetDialog()}
      <div className="formgrid grid mt-4">
        <div className="field col-4" style={{ paddingLeft: "5px" }}>
          <div className="formgrid grid">
            <div className="field mr-2">
              <Button label="Approve All" type="button" className="p-button-rounded" onClick={() => approveAllTimesheetRecall(reviewRecallTimesheet)} disabled={empReviewRecallTimesheetDisabled} />
            </div>
            <div className="field">
              <Button label="Reject All" type="button" className="p-button-rounded p-button-danger" onClick={() => rejectAllTimesheetRecall(reviewRecallTimesheet)} disabled={empReviewRecallTimesheetDisabled} />
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default ReviewRecallTimesheet;